<script>
  // The builder's header shows the one BLV balance (credits) instead of slot counters (Miles 2026-11-05: no buyer-type or
  // offer limits). Tap → the Credits page.
  import { supabase } from '../lib/supabase.js';
  let balance = $state(null);
  $effect(() => { supabase.rpc('fn_my_credits').then(({ data }) => { if (typeof data === 'number') balance = data; }); });
</script>

<button type="button" class="cp" onclick={() => window.dispatchEvent(new CustomEvent('go-pricing'))} title="Credits">
  💎 {balance == null ? '…' : balance.toLocaleString('en-US')} credits
</button>

<style>
  .cp { background: transparent; border: 1px solid rgba(255,255,255,0.14); color: var(--text); border-radius: 999px;
    padding: 5px 12px; font: inherit; font-size: 12px; cursor: pointer; }
</style>
